/**
 * Generates an interview link URL based on the invitation token
 */
export const getInterviewLink = (invitationToken: string): string => {
  return `/interview/${invitationToken}`;
}; 
